// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/init.css'
import './assets/swiper.min.css'
import axios from 'axios'


Vue.use(ElementUI);
import AutoFocus from 'vue-auto-focus'
Vue.use(AutoFocus)

import store from './store'    //store指的是文件store，存储vuex数据的文件stroe.js
import Vuex from 'vuex'
Vue.use(Vuex)
import promise from 'es6-promise';
promise.polyfill();

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js